export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export interface LogEntry {
  at: number
  level: LogLevel
  message: string
}

const MAX_ENTRIES = 60
const entries: LogEntry[] = []

function record(level: LogLevel, message: string): void {
  entries.push({ at: Date.now(), level, message })
  if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES)
}

function emit(level: LogLevel, message: string, detail: unknown[]): void {
  record(level, message)
  const line = `[infoscreens] ${message}`
  if (level === 'error') console.error(line, ...detail)
  else if (level === 'warn') console.warn(line, ...detail)
  else if (level === 'info') console.info(line, ...detail)
  else console.debug(line, ...detail)
}

export const logger = {
  debug: (message: string, ...detail: unknown[]) => emit('debug', message, detail),
  info: (message: string, ...detail: unknown[]) => emit('info', message, detail),
  warn: (message: string, ...detail: unknown[]) => emit('warn', message, detail),
  error: (message: string, ...detail: unknown[]) => emit('error', message, detail),
}

/** Newest first, for the on-screen debug overlay. */
export function recentLogs(limit = 12): LogEntry[] {
  return entries.slice(-limit).reverse()
}

export function describeError(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return JSON.stringify(error)
}
